<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <v-btn
                v-if="false"
                outlined
                color="blue darken-2"
                rounded
                dark
                depressed
                small
                @click="$refs.dialogAddEquipe.show()"
              >
                <v-icon left>mdi-plus-circle</v-icon>Adicionar Equipe
              </v-btn>
            </v-col>
          </v-row>
          <v-form ref="formBusca">
            <v-row dense>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa
                  :multiple="true"
                  @onChanged="empresas = $event"
                  @onEmpresas="empresasArray = $event"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            group-by="nomeEmpresa"
            :headers="table.headers"
            :items="table.dados"
            :search="table.search"
          >
            <template v-slot:group.header="{ items }">
              <td colspan="10" class="text-start">
                <v-icon color="blue darken-1" small>mdi-arrow-right-drop-circle</v-icon>
                {{ items[0].nomeEmpresa }}
              </td>
            </template>
            <template v-slot:item.acoes="{item}">
              <v-tooltip v-if="$ability.can('Editar','Equipes')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogEditarNomeEquipe.show(item)"
                  >
                    <v-icon>mdi-label</v-icon>
                  </v-btn>
                </template>
                Editar Nome da Equipe
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogViewEquipe.show(item)"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                Visualizar Equipe
              </v-tooltip>
              <v-btn
                v-if="$ability.can('Editar','Equipes')"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.dialogEditarEquipe.show(item, table.dados)"
              >
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <DialogViewEquipe ref="dialogViewEquipe" />
        <DialogEditarNomeEquipe @OnSaved="buscar" ref="dialogEditarNomeEquipe" />
        <DialogAddEquipe ref="dialogAddEquipe" />
        <DialogEditarEquipe ref="dialogEditarEquipe" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Equipe from "@/services/equipe";
import Colaborador from "@/services/colaborador";
export default {
  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogViewEquipe: () => import("./components/DialogViewEquipe"),
    DialogEditarNomeEquipe: () => import("./components/DialogEditarNomeEquipe"),
    DialogAddEquipe: () => import("./components/DialogAddEquipe"),
    DialogEditarEquipe: () => import("./components/DialogEditarEquipe")
  },
  data() {
    return {
      empresas: null,
      empresasArray: [],
      table: {
        search: "",
        headers: [
          { text: "Nome", value: "nome" },
          { text: "Supervisor", value: "supervisor" },
          { text: "Ações", value: "acoes" }
        ],
        dados: []
      }
    };
  },
  methods: {
    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          this.table.dados = [];
          const response = await new Equipe().selectAll(
            this.empresas,
            this.empresasArray
          );
          response.forEach(async element => {
            this.table.dados.push({
              id: element.id,
              cnpj: element.cnpj,
              nomeEmpresa: element.nomeEmpresa,
              ativo: element.ativo,
              codigoEquipe: element.codigoEquipe,
              colaboradores: element.colaboradores,
              nome: element.nome,
              supervisor: await this.getSupervisor(element.supervisor)
            });
          });
        } catch (error) {
          this.$swal.error(error);
        }
      }
    },
    async getSupervisor(item) {
      let col = null;
      if (item !== "" || item !== null) {
        try {
          const response = await new Colaborador().getById(item);
          col = response.nome;
        } catch (error) {
          console.error(error);
        }
      }
      return col;
    }
  }
};
</script>

<style>
</style>
